import { render, staticRenderFns } from "./DetailsTab.vue?vue&type=template&id=245dbc0d&scoped=true"
import script from "./DetailsTab.vue?vue&type=script&lang=js"
export * from "./DetailsTab.vue?vue&type=script&lang=js"
import style0 from "./DetailsTab.vue?vue&type=style&index=0&id=245dbc0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245dbc0d",
  null
  
)

export default component.exports